module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div name=\"form-content\" class=\"wh100 content\">\n    <ul name=\"crumbs\" class='crumbs'></ul>\n    <div class=\"top\">\n        <div>\n            <h2>")
    ; __append(escapeFn( widget.title ))
    ; __append("</h2>\n\n            <div name=\"user-profile\"></div>\n            <h3>Персональные данные</h3>\n\n            <div class='user-profile' name=\"profile\">\n                <div class='user-profile-col'>\n                    <div id='userProfileAva'></div>\n                </div>\n                <div class='user-profile-col'>\n                    <div name=\"profile-data\"></div>\n                </div>\n				")
    ;  if (isRoot() || check("Agronomy.SelfProfile", Security.AccessMode.Update)) { 
    ; __append("\n                <div class='user-profile-col'>\n                    <div name=\"edit-profile\" class='user-profile-tool' on-click=\"onProfileEditClick\">\n                        Редактировать\n                    </div>\n                    <div name=\"save-profile\" class='user-profile-tool' on-click=\"onProfileSaveClick\" style=\"display: none\">\n                        Сохранить\n                    </div>\n                    <div name=\"cancel-profile\" class='user-profile-tool' on-click=\"onProfileCancelClick\" style=\"display: none\">\n                        Отмена\n                    </div>\n                </div>\n				")
    ;  } 
    ; __append("\n            </div>\n        </div>\n\n        <div name=\"section-groups\" class=\"section-groups\"></div>\n    </div>\n    <div class='footer'>\n        <!--<div name=\"close\" class='button' on-click=\"onCloseClick\">-->\n            <!--Вернуться-->\n        <!--</div>-->\n    </div>\n</div>\n")
  }
  return __output.join("");

}